
import Vue from 'vue';

import App from './App.vue';

import config from "./config";

import moment from "moment";

import VueMeta from 'vue-meta'

import router from "./router";

import axios from 'axios';

Vue.use(VueMeta, {
  refreshOnceOnNavigation: true
});

Vue.config.productionTip = false;

Vue.use(require('vue-moment'));

/*import Loading from 'vue-loading-overlay';

import 'vue-loading-overlay/dist/vue-loading.css';

Vue.use(Loading, {
    color: '#27AE60',
    container: null,
    canCancel: false,
});*/

Vue.prototype.$http = axios.create({
    baseURL: config.apiUrl,
});

Vue.filter('speed_rating', function (speed_rating) {
    speed_rating = parseInt(speed_rating);
    return isNaN(speed_rating) || speed_rating <= 0 ? ' — ' : speed_rating;
});

Vue.filter('statusInfo', function (status) {
    return config.status.FINISH === status ? 'Finished' : 'In game';
});

Vue.filter('statusName', function (game, r = '') {
    if(game.active_time_in && game.time_limit){
        if(Vue.prototype.$moment(game.active_time_in).isValid() && Vue.prototype.$moment(game.active_time_in).add(game.time_limit, 's').unix() < Vue.prototype.$moment().unix()){
            return r === 'bool' ? true : config.statusName[8];
        }
    }
    return r === 'bool' ? false : config.statusName[game.status];
});

Vue.filter('timestamp', function (value) {

    if(value === '' || value === null || value === 'null'){
        return moment().unix();
    }

    return moment(value).unix();
});

Vue.filter('timediff', function (value, value2 = null) {
    return (value2 ? moment(value2).unix() : moment().unix()) - value;
});

Vue.filter('datetime', function (value, format, def = '') {
    if(format === undefined){
        format = 'YYYY-MM-DD HH:mm';
    }
    return value !== '' && value !== null && moment(value).isValid() ? moment(value).format(format) : def;
});

Vue.filter('timeToString', (value = '') => {

    if(value === undefined || value === null){
        value = '';
    }

    let sec_num = parseInt(value.toString(), 10); // don't forget the second param
    let hours   = Math.floor(sec_num / 3600);
    let minutes = Math.floor((sec_num - (hours * 3600)) / 60);
    let seconds = sec_num - (hours * 3600) - (minutes * 60);

    if(!isNaN(hours) && hours > 0){
        hours += 'h';
    } else {
        hours = '';
    }

    if (!isNaN(minutes) && minutes > 0){
        minutes += 'm';
    } else {
        minutes = '';
    }

    if(!isNaN(seconds) && seconds > 0){
        seconds += 's';
    } else {
        seconds = '';
    }

    let time = [hours, minutes, seconds].filter(t => t !== '' && t !== 0).join(' ');

    return time === '' ? ' — ' : time;

});

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
